import { styled } from "@mui/material/styles";
import { AccordionSummary } from "@mui/material";

export const AccordionSummaryWithSpacing = styled(AccordionSummary)(
  ({ theme }) => ({
    "& .MuiAccordionSummary-content": {
      justifyContent: "space-between",
      alignItems: "baseline",
      paddingRight: theme.spacing(4),
    },
  }),
);
